import(/* webpackMode: "eager", webpackExports: ["FeaturesSection"] */ "/vercel/path0/apps/web/src/app/components/landing/features-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterSection"] */ "/vercel/path0/apps/web/src/app/components/landing/footer-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroSection"] */ "/vercel/path0/apps/web/src/app/components/landing/hero-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LandingScrollSnap"] */ "/vercel/path0/apps/web/src/app/components/landing/landing-scroll-snap.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PricingSection"] */ "/vercel/path0/apps/web/src/app/components/landing/pricing-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TopNav"] */ "/vercel/path0/apps/web/src/app/components/landing/top-nav.tsx");
